import { useMutation } from '@tanstack/react-query';
export type CreateRaceData = {
  name: string;
  date: string;
  distance: string;
  url: string;
  description?: string;
  gpx_file_url?: string;
  gpx_file?: File;
};

export const useCreateRaceRequest = (accessToken: string | undefined) => {
  return useMutation({
    mutationFn: async (raceData: CreateRaceData) => {
      if (!accessToken) {
        throw new Error('No access token available');
      }

      const formData = new FormData();
      formData.append('name', raceData.name);
      formData.append('date', raceData.date);
      formData.append('distance', raceData.distance);
      formData.append('url', raceData.url);
      formData.append('description', raceData.description || '');

      if (raceData.gpx_file_url && !raceData.gpx_file) {
        formData.append('gpx_file_url', raceData.gpx_file_url);
      }

      if (raceData.gpx_file) {
        formData.append('gpx', raceData.gpx_file);
      }

      const response = await fetch(
        `${import.meta.env.REACT_APP_API_SERVICE_URI}/api/races`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        },
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to create race');
      }

      const data = await response.json();
      return data.race;
    },
  });
};
